import { tv } from 'tailwind-variants';

const styles = tv({
  slots: {
    base: `
      flex
      flex-col
      space-y-4
    `,
  },
});

export default styles;
